import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/error/error.component.ts